class CollectionToolbarFilter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const trigger = this.querySelector('[data-filter-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    event.preventDefault();
    const drawer = document.querySelector('#main-collection-filters menu-drawer');
    if (!drawer) return;
    const details = drawer.querySelector(':scope > details');
    const summary = details && details.querySelector(':scope > summary');
    if (!details || !summary) return;

    if (details.hasAttribute('open')) {
      drawer.closeMenuDrawer(new Event('click'), summary);
    } else {
      details.setAttribute('open', '');
      drawer.openMenuDrawer(summary);
    }
  }
}

customElements.define('collection-toolbar-filter', CollectionToolbarFilter);
